import { render, staticRenderFns } from "./BiotimeSyncList.vue?vue&type=template&id=e4f2770c&scoped=true&"
import script from "./BiotimeSyncList.vue?vue&type=script&lang=js&"
export * from "./BiotimeSyncList.vue?vue&type=script&lang=js&"
import style0 from "./BiotimeSyncList.vue?vue&type=style&index=0&id=e4f2770c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f2770c",
  null
  
)

export default component.exports